<!-- JWNET未加入業者 編集 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-alert
      outlined
      dense
      color="light-blue darken-4"
    >
      事業者名：{{ trader.name }}
    </v-alert>
    <Form
      v-if="trader"
      :master-trader="trader"
      @editCallback="searchTrader"
    />

    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
import Form from './_Form'
import { mapActions } from 'vuex'

export default {
  name: 'DriverMasterTraderEdit',
  components: {
    Confirm,
    Form,
  },
  mixins: [
  ],
  data () {
    return {
      breadcrumbs: [
        { text: 'JWNET未加入業者一覧', disabled: false, to: '/driver/masters/non_subscribe_traders', exact: true },
        { text: 'JWNET未加入業者編集', disabled: true, to: '' },
      ],
      trader: {}
    }
  },
  computed: {
  },
  created() {
    this.searchTrader()
  },
  methods: {
    ...mapActions('DriverMasterNonSubscribeTrader', {
      showTrader: 'show'
    }),
    searchTrader () {
      this.showTrader({ id: this.$route.params.id }).then((content) => {
        this.trader = content
      })
    },
  },


}
</script>

<style lang="scss">

</style>
